import React from "react";

const designers = [

{ name:"Aman", cases:40 },
{ name:"Rahul", cases:35 },
{ name:"Neha", cases:34 },
{ name:"Priya", cases:28 }

];

const DesignerLeaderboard = () => (

<div className="card shadow-sm">

<div className="card-body">

<h5>Designer Ranking</h5>

<ol>

{designers.map((d,i)=>(

<li key={i}>
{d.name} — {d.cases} cases
</li>

))}

</ol>

</div>

</div>

);

export default DesignerLeaderboard;